import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';


const capitalizeFirstLetter = (str) => {
  if (!str) return ''; 
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase(); 
};


const Page3 = () => {
  const [activeTab, setActiveTab] = useState('sem1');

   const { city } = useParams(); 
    const [cityName, setCityName] =  useState(city ? capitalizeFirstLetter(city) : '');
  
    useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth' 
      });
      if (city) {
        setCityName(capitalizeFirstLetter(city)); 
      }
    }, [city]);

  const semesters = {
    sem1: {
      compulsory: [
        'Managerial Accounting',
        'Organizational Behavior',
        'Economics Analysis for Business',
        'Business Research Methodology',
        'Basics of Marketing',
        'Digital Business'
      ],
      electives: [
        {
          note: 'Maximum 3 courses to be selected from the following list',
          subjects: [
            'Management Fundamentals',
            'Indian Economy',
            'Entrepreneurship Development',
            'Essentials of Psychology for Managers',
            'Legal Aspects of Business',
            'Demand Analysis & Forecasting'
          ]
        },
        {
          note: 'Maximum 3 courses to be selected from the following list',
          subjects: [
            'Verbal Communication Lab',
            'Enterprise Analysis & Desk Research',
            'Selling & Negotiation Skills Lab',
            'MS Excel',
            'Business Systems & Procedures',
            'Managing Innovation',
            'Foreign Language – I'
          ]
        }
      ]
    },
    sem2: {
      compulsory: [
        'Marketing Management',
        'Financial Management',
        'Human Resources Management',
        'Operations & Supply Chain Management',
        'Marketing Research',
        'Consumer Behavior'
      ],
      electives: [
        {
          note: 'Any 3 courses to be selected from the following list',
          subjects: [
            'Contemporary Frameworks in Management',
            'Geopolitics & World Economic Systems',
            'Start Up and New Venture Management',
            'Qualitative Research Methods',
            'Business, Government & Society',
            'Business Process Re-engineering'
          ]
        },
        {
          note: 'Maximum 1 course to be selected from the following list',
          subjects: [
            'Written Analysis and Communication Lab',
            'Industry Analysis & Desk Research',
            'Entrepreneurship Lab',
            'SPSS',
            'Foreign Language – II'
          ]
        },
        {
          note: 'Maximum 2 courses to be selected from the following list',
          subjects: [
            'Integrated Marketing Communications',
            'Product & Brand Management',
            'Personal Selling Lab',
            'Digital Marketing - I',
            'Marketing of Financial Services - I',
            'Marketing of Luxury Products'
          ]
        }
      ]
    },
    sem3: {
      compulsory: [
        'Strategic Management',
        'Decision Science',
        'Summer Internship Project',
        'Services Marketing',
        'Sales & Distribution Management'
      ],
      electives: [
        {
          note: 'Any 3 courses to be selected from the following list',
          subjects: [
            'International Business Economics',
            'International Business Environment',
            'Project Management',
            'Quality Management',
            'Corporate Governance',
            'Management of Non-profit organizations'
          ]
        },
        {
          note: 'Maximum 3 courses to be selected from the following list',
          subjects: [
            'Business to Business Marketing',
            'International Marketing',
            'Digital Marketing - II',
            'Marketing of Financial Services - II',
            'Marketing Analytics',
            'Marketing of High Technology Products'
          ]
        }
      ]
    },
    sem4: {
      compulsory: [
        'Enterprise Performance Management',
        'Indian Ethos & Business Ethics',
        'Marketing 4.0',
        'Marketing Strategy'
      ],
      electives: [
        {
          note: 'Any 2 courses to be selected from the following list',
          subjects: [
            'Global Strategic Management',
            'Elective Competing in Global Markets',
            'Elective Cyber Laws',
            'CSR & Sustainability'
          ]
        },
        {
          note: 'Maximum 2 courses to be selected from the following list',
          subjects: [
            'Customer Relationship Management',
            'Rural & Agriculture Marketing',
            'Tourism & Hospitality Marketing',
            'Retail Marketing',
            'Retailing Analytics',
            'Marketing to Emerging Markets & Bottom of the Pyramid'
          ]
        }
      ]
    }
  };

  return (
    <div className="max-w-4xl mx-auto py-8 px-4">
      <h1 className="text-4xl font-bold mb-4 text-center">
      {cityName ? `MBA in Marketing and Sales in ${cityName}` : `MBA in Marketing and Sales`}
        </h1>

      {/* About Section */}
      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-2">About MBA in Marketing</h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          Marketing and Sales focus on identifying and understanding customer needs to drive business growth. Sales involve activities related to promoting and selling goods or services, while marketing encompasses strategies for promoting, distributing, and positioning a product or service in the market.
        </p>
        <p className="text-gray-700 leading-relaxed mb-4">
          An MBA in Marketing and Sales is a specialized business program designed to prepare students for the dynamic and competitive marketing world. The curriculum covers topics like consumer behavior, market research, advertising, digital marketing, strategic marketing, and sales techniques. It combines theoretical knowledge with practical applications, enabling students to tackle challenges in the global marketing and sales landscape.
        </p>
      </section>

      {/* Training Section */}
      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-2">How Do We Train?</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>Develop strategic plans that align marketing efforts with financial goals to achieve overall business objectives.</li>
          <li>Analyze marketing challenges, forecast sales, and understand growth patterns using advanced tools.</li>
          <li>Understand customer needs, track market trends, and spot new opportunities for business growth.</li>
          <li>Design marketing strategies to enhance customer engagement and boost sales.</li>
        </ul>
      </section>

      {/* Profile-Oriented Training Section */}
      <section className="bg-white p-4 mb-6 rounded-lg shadow-md">
        <h2 className="text-2xl font-semibold mb-2">Profile-Oriented Training in MBA Marketing</h2>
        <p className="mb-4">At FBS, you get profile-oriented training designed for various Sales and Marketing job roles. These ensure you are ready for a variety of career opportunities.</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <p className="font-medium">• Business to Business</p>
            <p className="font-medium">• Business to Consumer</p>
            <p className="font-medium">• Marketing Analytics Training</p>
            <p className="font-medium">• Channel Management Training</p>
          </div>
          <div>
            <p className="font-medium">• Retail Management</p>
            <p className="font-medium">• Market Research</p>
            <p className="font-medium">• Media Sales</p>
            <p className="font-medium">• Pre Sales</p>
          </div>
        </div>
      </section>

      {/* Why MBA Section */}
      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-2">Why Pursue an MBA in Sales and Marketing?</h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          An MBA in Marketing and Sales provides the expertise needed to succeed in high-paying roles within the Marketing and Digital Marketing sectors. The program enhances your professional profile, making you a strong candidate for various career paths.
        </p>
        <p className="text-gray-700 leading-relaxed mb-4">
          With the rise of digital and social media platforms, an MBA in Marketing also prepares you for roles such as Brand Manager, Digital Media Strategist, Marketing Analyst, Product Manager, and Media Planner. Many professionals in this field enjoy competitive starting salaries and have the potential for advancement into leadership positions.
        </p>
      </section>

      {/* Who Should Consider Section */}
      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-2">Who Should Pursue an MBA in Marketing?</h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          Graduates from fields such as BA, B.Com, or BBA, or working professionals looking to advance their careers should consider an MBA in Marketing. This program provides a strong foundation for entering the corporate world or advancing in current roles.
        </p>
        <p className="text-gray-700 leading-relaxed">
          Many students spend years preparing for competitive government exams. However, pursuing an MBA in Marketing can fast-track your career to managerial roles in top companies, often with higher starting salaries compared to government job entry levels.
        </p>
      </section>

      {/* Eligibility Section */}
      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-2">Eligibility Criteria for MBA in Marketing</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>Completion of education under the 10+2+3 or 10+2+4 system.</li>
          <li>A minimum of 50% aggregate marks in 10th, 12th, and graduation.</li>
          <li>Qualifying aptitude tests such as CAT, XAT, MAT, CMAT, or PMAT (FBS’s internal test).</li>
          <li>Applicants with work experience may receive additional weightage.</li>
        </ul>
      </section>

      {/* Entrance Exam Section */}
      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-2">MBA in Marketing Entrance Exam</h2>
        <p className="text-gray-700 leading-relaxed">
          To secure admission into the MBA in Marketing program, candidates must take the PMAT exam (FBS's internal aptitude test). Admissions are based on the PMAT exam score.
        </p>
      </section>

      {/* Semester and Syllabus Section */}
      <div className="w-full mx-auto p-4">
        <div className="bg-white shadow-lg rounded-lg">
          <div className="border-b">
            <nav className="flex flex-wrap justify-center">
              {['SEMESTER I', 'SEMESTER II', 'SEMESTER III', 'SEMESTER IV'].map((sem, idx) => (
                <button
                  key={idx}
                  onClick={() => setActiveTab(`sem${idx + 1}`)}
                  className={`px-6 py-3 font-medium text-sm transition-colors
                    ${activeTab === `sem${idx + 1}` 
                      ? 'border-b-2 border-blue-500 text-blue-600' 
                      : 'text-gray-500 hover:text-gray-700'}`}
                >
                  {sem}
                </button>
              ))}
            </nav>
          </div> 
          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-orange-500">
                  <th className="p-4 text-left text-sm font-medium text-gray-600 border">Semester</th>
                  <th className="p-4 text-left text-sm font-medium text-gray-600 border">Subject</th>
                  <th className="p-4 text-left text-sm font-medium text-gray-600 border">Type</th>
                </tr>
              </thead>
              <tbody>
                {/* Compulsory Subjects */}
                <tr>
                  <td className="p-4 border">SEMESTER {activeTab.slice(-1)}</td>
                  <td className="p-4 border">
                    <ul className="list-disc pl-5 space-y-1">
                      {semesters[activeTab].compulsory.map((subject, idx) => (
                        <li key={idx}>{subject}</li>
                      ))}
                    </ul>
                  </td>
                  <td className="p-4 border">Compulsory</td>
                </tr>

                {/* Electives Sections */}
                {semesters[activeTab].electives.map((section, sectionIdx) => (
                  <React.Fragment key={sectionIdx}>
                    <tr>
                      <td colSpan="3" className="p-4 border font-medium text-center bg-gray-50">
                        {section.note}
                      </td>
                    </tr>
                    <tr>
                      <td className="p-4 border">SEMESTER {activeTab.slice(-1)}</td>
                      <td className="p-4 border">
                        <ul className="list-disc pl-5 space-y-1">
                          {section.subjects.map((subject, idx) => (
                            <li key={idx}>{subject}</li>
                          ))}
                        </ul>
                      </td>
                      <td className="p-4 border">Electives</td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Page3;
